import { z } from 'zod';
import { normalizeLinkMetadata } from '@/lib/url-metadata/normalize';
import type { LinkMetadata } from './types';

const optionalString = z.union([z.string(), z.null()]).optional();

export const LinkMetadataSchema = z
  .object({
    url: optionalString,
    title: optionalString,
    description: optionalString,
    image: optionalString,
    siteName: optionalString,
    video: optionalString,
    favicon: optionalString,
    embeddableStatus: z.enum(['allow', 'deny', 'unknown']),
    metadata: z.unknown().optional(),
    error: z.unknown().optional(),
  })
  .passthrough();

export const FetchUrlMetadataResultSchema = z
  .object({
    metadata: z.record(z.string(), LinkMetadataSchema).optional(),
    errors: z.record(z.string(), z.string()).optional(),
  })
  .partial();

export const LinkPreviewErrorPayloadSchema = z
  .object({
    message: z.union([z.string(), z.null()]).optional(),
    code: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();

export type ParsedLinkMetadata = z.infer<typeof LinkMetadataSchema>;

export const parseLinkMetadata = (value: unknown): LinkMetadata | null => {
  const parsed = LinkMetadataSchema.safeParse(value);
  if (!parsed.success) {
    return null;
  }
  const fallbackUrl = typeof parsed.data.url === 'string' ? parsed.data.url : undefined;
  return normalizeLinkMetadata(parsed.data, fallbackUrl);
};
